import OnIdle from '@mindtickle/ui-shell-core/IdleUntilUrgent';
import { MomentLocaleProvider } from '@mindtickle/ui-shell-core/MomentLocale';
import { getStoredLocale } from '~/utils/userLocaleStorage';
import { isAdminSite } from '~/utils';

import AdminLayout from './Admin';
import LearnerLayout from './Learner';

import DeferredIntegrations from '~/components/Integrations/components/DeferredIntegrations';
import { DEFAULT_LOCALE } from '../DateTranslation';

type TLayoutProps = { children: JSX.Element };

export const Layout = (props: TLayoutProps) => {
  const isAdmin = !!isAdminSite();
  const LayoutComponent = isAdmin ? AdminLayout : LearnerLayout;
  const locale = getStoredLocale()?.locale ?? DEFAULT_LOCALE;

  const children = (
    <MomentLocaleProvider locale={locale} isAdmin={isAdmin}>
      {props.children}
      <OnIdle>
        <DeferredIntegrations />
      </OnIdle>
    </MomentLocaleProvider>
  );

  return <LayoutComponent>{children}</LayoutComponent>;
};
